import axios from 'axios';

// Sito ecommerce → Salute del sito: scansioni del sito pubblico, problemi e pagine
const state = {
	scansioni: [],
	dettaglio: null,
	pagine: [],
};

const getters = {
	getScansioni: state => state.scansioni,
	getDettaglio: state => state.dettaglio,
	getPagine: state => state.pagine,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path = '') => `${context.rootGetters['settings/getUrl']}sitehealth${path}`;

const actions = {
	fetchScansioni: async context => {
		const res = await axios.get(url(context), auth(context));
		context.commit('setScansioni', res.data.data);
		return res.data.data;
	},
	// la pagina salva il dettaglio solo se e' la risposta piu' recente (vedi Index.vue)
	fetchDettaglio: async (context, id) => (await axios.get(url(context, `/${id}`), auth(context))).data.data,
	// la lista delle pagine usa i settings di listRouteState (filtri, ordinamento, paginazione)
	fetchPagine: async (context, { id, settings }) => {
		const { sortBy, page, itemsPerPage } = settings.options;
		const f = settings.filters || {};
		const res = await axios.get(url(context, `/${id}/pages`), {
			...auth(context),
			params: {
				sort: sortBy[0] || 'problemi',
				page,
				limit: itemsPerPage,
				q: settings.search || undefined,
				codice: f.codice || undefined,
				livello: f.livello || undefined,
				status: f.status || undefined,
				indicizzabile: f.indicizzabile || undefined,
				novita: f.novita || undefined,
			},
		});
		context.commit('setPagine', res.data.data.items);
		return res.data.data;
	},
	fetchPagina: async (context, { id, pageId }) => (await axios.get(url(context, `/${id}/pages/${pageId}`), auth(context))).data.data,
	// CSV con gli stessi filtri della lista: si scarica come file
	esporta: async (context, { id, settings }) => {
		const f = settings.filters || {};
		const res = await axios.get(url(context, `/${id}/export`), {
			...auth(context),
			responseType: 'blob',
			params: {
				q: settings.search || undefined,
				codice: f.codice || undefined,
				livello: f.livello || undefined,
				status: f.status || undefined,
				indicizzabile: f.indicizzabile || undefined,
				novita: f.novita || undefined,
			},
		});
		const nome = ((res.headers['content-disposition'] || '').match(/filename="([^"]+)"/) || [])[1] || 'salute-del-sito.csv';
		const link = document.createElement('a');
		link.href = URL.createObjectURL(res.data);
		link.download = nome;
		link.click();
		URL.revokeObjectURL(link.href);
	},
	verificaUrl: async (context, indirizzo) => (await axios.post(url(context, '/check-url'), { url: indirizzo }, auth(context))).data.data,
	ricontrolla: async (context, { id, pageId }) => (await axios.post(url(context, `/${id}/pages/${pageId}/recheck`), {}, auth(context))).data.data,
	fetchImpostazioni: async context => (await axios.get(url(context, '/settings'), auth(context))).data.data,
	salvaImpostazioni: async (context, impostazioni) => (await axios.put(url(context, '/settings'), impostazioni, auth(context))).data.data,
	avvia: async (context, impostazioni) => (await axios.post(url(context), impostazioni, auth(context))).data.data,
	annulla: async (context, id) => (await axios.post(url(context, `/${id}/cancel`), {}, auth(context))).data.data,
	destroyData: context => {
		context.commit('setDettaglio', null);
		context.commit('setPagine', []);
	},
};

const mutations = {
	setScansioni: (state, value) => {
		state.scansioni = value || [];
	},
	setDettaglio: (state, value) => {
		state.dettaglio = value;
	},
	setPagine: (state, value) => {
		state.pagine = value || [];
	},
	// avanzamento in diretta dal socket: aggiorna la scansione nella lista e, se e' quella aperta, nel dettaglio
	setAvanzamento: (state, { id, status, visitate, inSitemap, fase }) => {
		const aggiorna = c => {
			if (!c || String(c._id) !== String(id)) return;
			c.status = status || c.status;
			c.avanzamento = {
				...(c.avanzamento || {}),
				...(visitate !== undefined ? { visitate } : {}),
				...(inSitemap !== undefined ? { inSitemap } : {}),
				...(fase !== undefined ? { fase } : {}),
			};
		};
		state.scansioni.forEach(aggiorna);
		if (state.dettaglio) aggiorna(state.dettaglio.crawl);
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
